// The frame-dropping class so a real ComboboxField sits seamlessly inside an InputGroup — the group
// owns the single border + focus ring, so each segment must drop its OWN border and every shadow
// state. Covers BOTH combobox chromes: the popup trigger (`data-popup-open` / `focus-visible`) and the
// multi-select chips frame (`focus-within` / `has-[…:focus-visible]`). `text-sm` matches the group's
// inputs so all row text is one size. The `!` on shadow-none is load-bearing — twMerge can't dedupe the
// trigger's theme shadows against shadow-none without it.
export const SEAMLESS_TRIGGER = [
  'h-full rounded-none border-0 bg-transparent text-sm shadow-none',
  'hover:shadow-none!',
  'focus:border-transparent focus:shadow-none!',
  'focus-visible:border-transparent focus-visible:shadow-none!',
  'focus-within:border-transparent focus-within:shadow-none! focus-within:hover:shadow-none!',
  'data-popup-open:border-transparent data-popup-open:shadow-none! data-popup-open:hover:shadow-none!',
  'has-[[data-slot=input-group-control]:focus-visible]:border-transparent has-[[data-slot=input-group-control]:focus-visible]:shadow-none!',
  'disabled:bg-transparent',
].join(' ');
